export enum RequestMode {
  HTTP = 'http',
  SSE = 'sse',
}

/**
 * Issue status options for GlitchTip
 */
export enum IssueStatus {
  RESOLVED = 'resolved',
  UNRESOLVED = 'unresolved',
  IGNORED = 'ignored',
}

/**
 * Sort options for issues list
 */
export enum SortOption {
  LAST_SEEN = '-last_seen',
  FIRST_SEEN = 'last_seen',
  NEWEST_CREATION_DATE = '-created',
  OLDEST_CREATION_DATE = 'created',
  MOST_FREQUENT = '-count',
  LEAST_FREQUENT = 'count',
  HIGHEST_PRIORITY = '-priority',
  LOWEST_PRIORITY = 'priority',
}

export enum PerformanceSortOption {
  NEWEST = '-created',
  OLDEST = 'created',
  SLOWEST = '-avg_duration',
  FASTEST = 'avg_duration',
  MOST_FREQUENT = '-transaction_count',
  LEAST_FREQUENT = 'transaction_count',
}

/**
 * Validates if the provided value is a valid RequestMode
 * @param mode - The value to validate
 * @returns Boolean indicating if the value is a valid RequestMode
 */
export function isValidRequestMode(mode: string): mode is RequestMode {
  return Object.values(RequestMode).includes(mode as RequestMode);
}

/**
 * Validates if the provided value is a valid IssueStatus
 * @param status - The value to validate
 * @returns Boolean indicating if the value is a valid IssueStatus
 */
export function isValidIssueStatus(status: string): status is IssueStatus {
  return Object.values(IssueStatus).includes(status as IssueStatus);
}

/**
 * Validates if the provided value is a valid SortOption
 * @param sort - The value to validate
 * @returns Boolean indicating if the value is a valid SortOption
 */
export function isValidSortOption(sort: string): sort is SortOption {
  return Object.values(SortOption).includes(sort as SortOption);
}

export function isValidPerformanceSortOption(sort: string): sort is PerformanceSortOption {
  return Object.values(PerformanceSortOption).includes(sort as PerformanceSortOption);
}